import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="panel">
      <h1 className="page-title">찾는 화면이 없습니다</h1>
      <p className="page-desc">주소가 바뀌었거나 삭제된 화면일 수 있습니다.</p>
      <Link className="btn" to="/">
        홈으로
      </Link>
    </div>
  )
}
